(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-vehicle"] && !Shopify.designMode) return;
  try {
    
  function showVehicleGalleryImage(section, thumb) {
    if (!section || !thumb) return;
    var mainImage = section.querySelector('.vehicle-gallery-main__image');
    if (!mainImage) return;
    mainImage.removeAttribute('srcset');
    mainImage.removeAttribute('sizes');
    mainImage.src = thumb.dataset.imageSrc;
    mainImage.alt = thumb.dataset.imageAlt || '';
    section.querySelectorAll('[data-vehicle-thumb]').forEach(function(item) { item.classList.remove('is-active'); });
    thumb.classList.add('is-active');
    thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
  }

  document.addEventListener('click', function(event) {
    var thumb = event.target.closest('[data-vehicle-thumb]');
    if (thumb) {
      var section = thumb.closest('.vehicle-detail-page');
      showVehicleGalleryImage(section, thumb);
    }
    var galleryArrow = event.target.closest('[data-gallery-previous],[data-gallery-next]');
    if (galleryArrow) {
      var gallerySection = galleryArrow.closest('.vehicle-detail-page');
      var thumbs = Array.prototype.slice.call(gallerySection.querySelectorAll('[data-vehicle-thumb]'));
      var activeIndex = thumbs.findIndex(function(item) { return item.classList.contains('is-active'); });
      if (activeIndex < 0) activeIndex = 0;
      var direction = galleryArrow.hasAttribute('data-gallery-next') ? 1 : -1;
      var nextIndex = (activeIndex + direction + thumbs.length) % thumbs.length;
      showVehicleGalleryImage(gallerySection, thumbs[nextIndex]);
    }
    var copyButton = event.target.closest('[data-copy-wechat]');
    if (copyButton) {
      var original = copyButton.textContent;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(copyButton.dataset.copyWechat).then(function() {
          copyButton.textContent = copyButton.dataset.copySuccess;
          window.setTimeout(function() { copyButton.textContent = original; }, 2200);
        });
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-header"]) return;
  try {
    
  document.querySelectorAll('[data-language-select]').forEach(function(select) {
    select.addEventListener('change', function() {
      localStorage.setItem('hao-jie-language-selected', 'true');
      select.form.submit();
    });
  });
  var header = document.querySelector('[data-auto-language]');
  if (header && header.dataset.autoLanguage === 'true' && !localStorage.getItem('hao-jie-language-selected')) {
    var language = (navigator.languages && navigator.languages[0]) || navigator.language || '';
    var preferred = language.toLowerCase().split('-')[0];
    document.querySelectorAll('[data-language-select]').forEach(function(select) {
      if (select.value !== preferred && Array.prototype.some.call(select.options, function(option) { return option.value.toLowerCase().split('-')[0] === preferred; })) {
        select.value = Array.prototype.find.call(select.options, function(option) { return option.value.toLowerCase().split('-')[0] === preferred; }).value;
        localStorage.setItem('hao-jie-language-selected', 'true');
        select.form.submit();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vehicle-payment"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', async function(event) {
    var form = event.target.closest('.vehicle-payment-form');
    if (!form || !event.submitter || !event.submitter.matches('[data-direct-checkout]')) return;
    event.preventDefault();
    var button = event.submitter;
    var status = form.querySelector('[data-payment-status]');
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    button.disabled = true;
    status.textContent = 'Preparing secure checkout...';
    try {
      await fetch(root + 'cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } });
      var response = await fetch(form.action, { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error('Unable to prepare checkout');
      window.location.assign(root + 'checkout');
    } catch (error) {
      status.textContent = 'Checkout could not be prepared. Please contact us on WhatsApp.';
      button.disabled = false;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
